import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * The page banner: a band carrying the NSC spectrum-wave graphic with the page's heading on it.
 *
 * The same image the public marketing site uses, and the heading is styled to the 40px/700/#444
 * that the page titles here had already settled on independently. Those titles lived in each
 * page's own template; this replaces them, and the string moved to the route's `data.heading`
 * so that the layout can render the band once rather than every page rendering its own.
 *
 * The host is `<classy-layout>`, which reads the heading off the activated route. A route with
 * no `heading` gets no band at all — which is every admin screen, by decision rather than by
 * omission. See the note in `example.routes.ts`.
 */
@Component({
    selector       : 'page-banner',
    standalone     : true,
    templateUrl    : './page-banner.component.html',
    styleUrls      : ['./page-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageBannerComponent
{
    /**
     * The page heading, rendered as the page's <h1>.
     *
     * Called `heading` rather than `title` because a `title` attribute on the host element is
     * also read by the browser as a tooltip, which would hover over the whole band.
     */
    readonly heading = input.required<string>();
}
